import { render, staticRenderFns } from "./NumberToggle.vue?vue&type=template&id=213cb065&scoped=true"
import script from "./NumberToggle.vue?vue&type=script&lang=js"
export * from "./NumberToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213cb065",
  null
  
)

export default component.exports